export enum OKRProgressType {
    manager,
    personel,
}

export const hasProgressType = (progressType:OKRProgressType[], type: OKRProgressType) => {
    return progressType.includes(type)
}